import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FileManagementRoute } from 'sections/file-management/routes';
import { SubNavProps } from '../SubNavLinks';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';

export const FileManagementSubNav = ({ setHeading }: SubNavProps) => {
  const { t } = useTranslation(['fileManagement', 'fileExport']);

  useEffect(() => {
    setHeading(t('nav.title'));
  });

  return (
    <>
      <AuthorisedSubNavLink
        permissions={['ManageClients']}
        to={FileManagementRoute.IMPORT_ANALYSIS}
        icon="file-import"
        label={t('nav.items.import')}
      />
      <AuthorisedSubNavLink
        permissions={['ManageClients']}
        to={FileManagementRoute.FILE_EXPORT}
        icon="file-export"
        label={t('fileExport:subNavLabel')}
      />
    </>
  );
};
